import React from 'react'
import PropTypes from 'prop-types'
import { SocialLinks } from 'LiveBoard/components/shared/SellerCard/SocialLinks'

import './style.css.scss'

const ContactDetails = ({seller}) => {
  const onLinkClick = (e) => e.stopPropagation()

  return (
    <div className="seller-contact-details">
      <a className="email"
        href={`mailto:${seller.email}`}
        onClick={onLinkClick} >
        <span className="icon-email" />
      </a>
      <a className="phone"
        href={`tel:${seller.phone}`}
        onClick={onLinkClick} >
        <span className="icon-phone" />
      </a>
      <SocialLinks data={seller} />
    </div>
  )
}

ContactDetails.propTypes = {
  seller: PropTypes.object.isRequired
}

export default ContactDetails
